import React, { Component } from 'react';
import { Redirect, Route } from 'react-router-dom'
import $ from 'jquery';
import TopNav from '../components/TopNav';
import { Container, Button, lightColors } from 'react-floating-action-button'
import '../bootstrap';
import 'bootstrap-imageupload';
import TableInfoBar from './TableInfoBar';
import LoginModal from './modal/LoginModal';
import ConfirmModal from './modal/ConfirmModal';
import Axios from 'axios';
import { getImageFullUrl, isFullUrl } from '../app/Common/Enum/helper';

class CategoryContent extends Component {
    constructor(props) {
        super(props)
        this.state = {
            navHeight: "",
        }
        this.navRefs = React.createRef()
        this.confirmModalRef = React.createRef()
    }

    componentDidMount() {
        if (!this.props.isAdmin) {
            this.props.app.loadTableIfNull(this.props.tableId);
        }
        // this.props.app.loadTableIfNull(table_id);
        $(document).trigger('CategoryContent.componentDidMount.completed')
        this.updateNavHeight()

        $(window).on('resize', this.onWindowResize)
    }
    componentWillUnmount() {
        $(window).off('resize', this.onWindowResize)
    }
    getColumnCount = () => {
        const width = window.innerWidth
        const columns = Math.floor(width / 300)
        // Minimum 2 column
        return columns >= 2 ? columns : 2
    }
    onWindowResize = () => {
        if (this.lastColumnCount != this.getColumnCount()) {
            this.forceUpdate()
        }
    }
    getGridTemplateColumns = () => {
        const columns = this.getColumnCount()
        this.lastColumnCount = columns
        const colWidth = Math.floor(100 / columns)
        let getGridTemplateColumns = []
        for (let i = 0; i < columns; i++) {
            getGridTemplateColumns.push( `calc(${colWidth}% - 5px)` )
        }
        return getGridTemplateColumns.join(" ")
    }
    componentDidUpdate() {
        this.updateNavHeight()
    }

    updateNavHeight = () => {
        if (this.navRefs.current && this.navRefs.current.navHeight) {
            let latestNavHeight = parseInt(this.navRefs.current.navHeight) + "px"
            if (this.state.navHeight != latestNavHeight) {
                this.setState({
                    navHeight: latestNavHeight
                })
            }
        }
    }
    isMultiMenu = () => {
        return this.props.app.isMerchantHasFeature('is_multi_menu')
    }
    goBackToChooseMenu = () => {
        this.props.app.setState({
            selectedMerchantMenuId: null
        })
    }
    cancelOrder = (confirmNewDialog) => {
        confirmNewDialog.isLoading(true)
        let success = false
        Axios.post(`/table_sessions/${table_session_id}/cancel_order`)
            .then((res) => {
                success = true
                // pageReload.goTo(`/${this.props.match.params.tableQR}`)
            }).catch((error) => {
                alert(error.message)
            }).finally(() => {
                setTimeout(() => {
                    confirmNewDialog.close()
                }, success ? 8000 : 200) // Success, keep progress bar a while waiting for page refresh
            })
    }
    onChooseMenuClicked = () => {
        const { current_session } = this.props.app.state
        if (current_session) {
            const onClose = () => {
                this.setState({
                    confirmModal: null,
                })
            }
            this.setState({
                confirmModal: <ConfirmModal
                    message={"Changing menu will discard all your current order, confirm?"}
                    buttonLayout="vertical"
                    onClose={onClose}
                    ref={this.confirmModalRef}
                    onYes={() => {
                        if (this.confirmModalRef.current) {
                            this.cancelOrder(this.confirmModalRef.current)
                        }
                    }}
                    onNo={onClose}
                />
            })
            return
        }
        else {
            this.goBackToChooseMenu()
        }
    }

    render() {
        if (!this.props.app.isReadyFor(this)) {
            return (<div></div>);
        }
        let paddingTop = {}
        if (this.state.navHeight != "") {
            paddingTop = {
                paddingTop: this.state.navHeight
            }
        }
        let image_path = (this.props.app.state.merchant && this.props.app.state.merchant.logo_url)?this.props.app.state.merchant.display_logo : "";
        let styling = this.props.app.isMerchantHasFeature('show_background_image_in_user_app')

        let merchantMenu = null
        let merchantMenuName = null
        if (this.isMultiMenu()) {
            if (this.props.app.state.selectedMerchantMenuId) {
                merchantMenu = this.props.app.state.merchantMenus.find(mm => mm.id == this.props.app.state.selectedMerchantMenuId)
                let arMerchantMenu = []
                arMerchantMenu.push(<span>{merchantMenu && (merchantMenu["name_"+window.selectedLang] || merchantMenu["name_en"])}</span>)

                if (merchantMenu.time_start && merchantMenu.time_end) {
                    const formatTime = (timeStr) => {
                        return moment(timeStr, "HH:mm").format("hh:mm a")
                    }
                    arMerchantMenu.push(<span>{`${formatTime(merchantMenu.time_start)} - ${formatTime(merchantMenu.time_end)}`}</span>)
                }
                merchantMenuName = arMerchantMenu.map((c, index) => <div key={index}>{c}</div>)
            }
        }
        return (
            <div>
            {styling && <img src={image_path} style={{ position: "absolute", bottom: "50%", left: "50%", marginLeft: "-125px", marginBottom: "-125px", width: "250px", height: "250px", opacity: "0.4", zIndex: "0" }}/>}
                {this.state.confirmModal}
                {
                    <TopNav table={this.props.app.state.table}
                        ref={this.navRefs}
                        isAllowSearchbar={true}
                        title={lang.category}
                        orders={this.props.app.state.orders}
                        backLabel={lang.back} back="/table"
                        backButton={false}
                        pickup={this.props.app.state.table.pickup}
                        pin={this.props.app.state.current_session !== null && table_session_id !== null ? <button className="btn btn-primary btn-sm" onClick={this.showPinNumber}>{lang.show_pin}</button> : ''}
                        session={this.props.app.state.current_session}
                        tableQR={this.props.match.params.tableQR}
                        merchantInfo={this.props.app.state.merchant}
                        showCheckIn={!this.props.app.isMerchantHasFeature('disable_check_in')}
                    />
                }

                <div className="container body-content" style={{...paddingTop}}>
                    <TableInfoBar table={this.props.app.state.table} app={this.props.app} style={{ marginTop: "0px", marginBottom: "5px", backgroundColor: "white", marginLeft: "-15px", marginRight: "-15px", padding: "0px 15px" }} />
                    <PhoneNumberAndPaxBar app={this.props.app}/>
                    {
                        this.props.app.state.merchant && this.props.app.state.merchant.announcement_text &&
                        <div className="container-fluid marquee" style={{height: "25px", fontSize: "larger", fontFamily: "cursive", marginBottom: "10px"}}>
                            <div>
                                <span>{this.props.app.state.merchant.announcement_text}</span>
                                <span>{this.props.app.state.merchant.announcement_text}</span>
                            </div>
                        </div>
                    }
                    {
                        this.props.app.isMultiMenu() &&
                        <div style={{display: "flex"}} className="mb-1">
                            <div style={{flex: "1 0 100px"}}>
                            {
                                !!merchantMenuName && <h4>{merchantMenuName}</h4>
                            }
                            </div>
                            <div style={{textAlign: "right", marginTop: "auto", marginBottom: "11px"}}>
                                <button className="btn btn-default btn-sm" onClick={this.onChooseMenuClicked}>{lang.change_menu}</button>
                            </div>
                        </div>
                    }

                    {
                        this.props.app.isMerchantHasFeature('allow_multi_column_category') ?
                        <div id="category-list" className="grid-container" style={{ width: "100%", gridTemplateColumns: this.getGridTemplateColumns() }}>
                            {this.getCategoryListing()}
                        </div> :
                        <div id="category-list" className="grid-container" style={{ width: "100%", gridTemplateColumns: "calc(50% - 5px) calc(50% - 5px)" }}>
                            {this.getCategoryListing()}
                        </div>
                    }
                </div>
                <Container>
                    <Button
                        tooltip={this.props.app.state.customer.firebase_uid || customerId ? lang.my_profile : lang.login}
                        icon="fas fa-user"
                        styles={{color: lightColors.white}}
                        rotate={false}
                        onClick={() => this.loginWithFirebase()} />
                </Container>
                { this.state.firebaseLoginModal }
            </div>
        );
    }
    loginWithFirebase = () => {
        if (this.props.app.state.customer.firebase_uid || customerId) {
            this.props.history.push(`/profile/${this.props.match.params.tableQR}`)
        }
        else {
            this.setState({
                firebaseLoginModal: <LoginModal
                    app={this.props.app}
                    onLoginSuccess={() => {
                        this.props.history.push(`/profile/${this.props.match.params.tableQR}`)
                    }}
                    onClose={() => this.setState({firebaseLoginModal: null})}
                />
            })
        }
    }
    getCategoryListing() {
        let me = this
        let btnStyle = {
            marginLeft: "5px"
        }

        let categoryList = this.props.app.state.filteredCategories
        categoryList.sort(function(a,b) {return a.sequence - b.sequence})

        return categoryList.map((category) => {
            let imageUrl = category.getImageUrl()
            let result = category.active?
                (<Route
                    key={category.id}
                    render={({ history }) => (
                        <div
                            id={`category-${category.id}`}
                            onClick={() => {
                                history.push(`/menu/${category.id}/${this.props.match.params.tableQR}`)
                                setTimeout(() => {
                                    $(document).trigger('NewMenuItem.ScrollTo', {categoryId: category.id})
                                }, 100);
                                $(document).trigger('CategoryContent.categoryClicked')
                            }}
                            className='grid-item card'
                            data-id={category.id}
                            style={{ backgroundColor: "white" }}>
                            <div className="card-image">
                                <img src={imageUrl} width="100%"></img>
                            </div>
                            <span style={{ display: "block" }}>
                                <h4 className="grid-title" style={{ marginBottom: "11px" }}><b>{category.name}</b></h4>
                            </span>
                        </div>
                    )} />) : ""

            return result;
        })
    }

    showPinNumber = () => {
        alert(lang.your_pin_number + this.props.app.state.table_session.pin);
    }
}

const PhoneNumberAndPaxBar = ({app}) => {
    let phoneNumber = localStorage.getItem('dine_in_phone_number') || ""
    let pax = localStorage.getItem('dine_in_pax') || ""
    if (phoneNumber && pax) {
        return <div style={{textAlign: "right", fontSize: "120%"}}>
            {phoneNumber} ({pax} {lang.pax}) <span className="ml-2" onClick={() => app.setState({isShowPhoneNumberAndPaxModal: true})}><i className="fa fa-edit"/></span>
        </div>
    }
    return null
}

export default CategoryContent;